import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";

import { getLevelsListPath } from "../resources/levels/levelsResourceConsts";
import { levelsResourceStruct } from "../resources/levels/levelsResourceStructs";

export const getLevelsQuery = (
  jsonApi: JsonApiClient,
  { userGroupId }: { userGroupId: string }
) => {
  return jsonApi.getMany({
    path: getLevelsListPath(userGroupId),
    responseStruct: getLevelsResponseStruct,
  });
};

const getLevelsResponseStruct = createResponseStruct({
  data: levelsResourceStruct,
});

export type GetLevelsResponse = sup.Infer<typeof getLevelsResponseStruct>;
